<template lang="html">
  <div class="file" v-if="show" :class="[fileClass,moreClass]">
    <div class="bar">
      <div class="w-bar"
      :style="{
        backgroundColor:config[typeColor].barColor,
        width:percent
        }"
      >
      </div>
    </div>
    <div class="top">
      <div class="project a" :title="project" v-if="type !== 2">
        <avatar
         :username="project"
         :size="45"
         :rounded="false"
         color="#607D8B"
         backgroundColor="transparent"
        >
        </avatar>
      </div>
      <div class="project" v-if="type === 2">
        <i class="material-icons" v-if="taskType === 'upload'">file_upload</i>
        <i class="material-icons" v-if="taskType === 'download'">file_download</i>
      </div>
      <div class="name" @click="showMore" :title="title">
        <span v-if="num > 1">({{num}})</span>{{title}}
      </div>
      <div class="status" v-show="type !== 2">
        <span v-show="type === 0">
          {{message.Al100}}
        </span>
        <span v-show="type === 1">
          {{message.Al101}}
        </span>
        <span  v-show="type === 3">
          {{message.Al102}}
        </span>
        <span v-show="type === 4">
          <i class="el-icon-loading"></i> {{message.Al103}}
        </span>
        <span v-show="type === 5">
          <i class="el-icon-loading"></i> {{message.Al104}}
        </span>
        <span v-show="type === 6">
          {{message.Al105}}
        </span>
        <span v-show="type === 7">
          {{message.Al150}}
        </span>
        <span class="show-error" v-show="type > 7">
            {{message.Al151}}
            <el-tooltip placement="bottom" effect="light">
            <div slot="content">
              Error: {{transferError.num}}<br/>
              {{transferError.describe}}<br/>
            </div>
            <i class="material-icons" style="vertical-align:middle">
              warning
            </i>
            </el-tooltip>
        </span>
      </div>
      <div class="status" v-show="type === 2">
        <span>
          {{message.Sl161}}:{{ project }}
        </span>
      </div>
      <div class="percent-line" v-if="listType !== 'all'">
        <div class="line">
          <div class="w-line"
          :style="{
            backgroundColor:config[typeColor].barColor,
            width:percent
            }"
          ></div>
        </div>
        <span>{{ percent }}</span>
      </div>
      <div class="info" v-if="type !== 2">
        <div class="percent">{{ percent }}</div>
        <div class="bit" v-show="type !== 2">{{ bitrate }}</div>
      </div>
      <div class="info" v-if="type == 2">
        <div class="time" style="height:35px">
          {{ com_time }}
          <!-- <span v-if="taskType === 'upload'" style="display:inline-block;color:#01d48f" class="icon">↑</span>
          <span v-if="taskType === 'download'" style="display:inline-block;color:#01d48f" class="icon">↓</span> -->
        </div>
      </div>
      <div class="operation" v-if="type !==4">
        <div class="o-icon" :title="message.Al106" @click="del(taskType,id)">
          <i class="material-icons n-op" v-show="iconShow.iconDelete">
            delete
          </i>
          <i class="el-icon-loading" v-show="!iconShow.iconDelete"></i>
        </div>
        <div class="o-icon" v-if="type==1||type==0" :title="message.Al107" @click="stop(taskType,id)">
          <div class="material-icons op" v-show="iconShow.iconStop">
            pause
          </div>
          <i class="el-icon-loading" v-show="!iconShow.iconStop"></i>
        </div>
        <div class="o-icon" v-if="type==3||type==7||type==8||type>8" :title="message.Al108" @click="start(taskType,id)">
          <i class="material-icons op" v-show="iconShow.iconStart">
            play_arrow
          </i>
          <i class="el-icon-loading" v-show="!iconShow.iconStart"></i>
        </div>
        <!-- <div class="o-icon" v-if="type === 2" @click="open(taskType,id)">
          <i class="material-icons" v-show="iconShow.iconTop">
            folder_open
          </i>
        </div> -->
        <div class="o-icon" v-if="type !== 2 && index !== 0 && type !== 1" :title="messageShow1" @click="top(taskType,id)">
          <i class="material-icons op" v-show="iconShow.iconTop">
            <!-- vertical_align_top -->
            near_me
          </i>
          <i class="el-icon-loading" v-show="!iconShow.iconTop"></i>
        </div>
      </div>
    </div>
    <!-- <div class="bottom">
      <div class="name" :title="project" v-show="type !== 2">{{message.Sl161}}: {{project}}</div>
      <div class="name" :title="project" v-show="type === 2" style="margin-left:45px">{{size}} / {{durationTime}}</div>
      <div class="status" v-if="listType !== 'all'">{{ size }}</div>
      <div class="status" v-if="listType === 'all'">{{message.Al109}}：{{ bitrate }}</div>
      <div class="over" v-if="listType !== 'all'">{{message.Al110}}：{{ remainTime }}</div>
    </div> -->
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Avatar from 'vue-avatar'
export default {
  components: {
    Avatar
  },
  computed: {
    ...mapGetters({
      transfer: 'transfer',
      space: 'space'
    }),
    transferError: function () {
      let data = {
        num: null,
        describe: null,
      }
      if (this.type - 5) {
        data.num = this.type - 5
      }
      if (this.type - 5 > 1000) {
        const key = 'l' + this.type - 10005
        data.describe = this.$lang.systemError[key]
      }
      return data
    },
    typeColor: function () {
      if (this.type > 8) {
        var typeColor = 8
      } else {
        typeColor = this.type
      }
      return typeColor
    },
    moreClass: function () {
      if (this.isMore) {
        if (this.isMore.id === this.id) {
          var className = 'choose'
        } else {
          className = ''
        }
      } else {
        className = ''
      }
      return className
    },
    messageShow1: function () {
      if (this.taskType === 'upload') {
        var language = this.message.Al180.l0
      } else {
        language = this.message.Al180.l1
      }
      return language
    },
  },
  watch: {
    'app.login': function (val) {
      if (val) {
        this.keepAppAlive()
      } else {
        clearInterval(this.keepFunc)
      }
    },
    opEvent: function (val) {
      if (val === 'stop') {
        if (this.type === 1 || this.type === 0) {
          this.stop(this.taskType, this.id)
        }
      }
      if (val === 'start') {
        if (this.type === 3 || this.type === 7 || this.type === 8 || this.type > 8) {
          this.start(this.taskType, this.id)
        }
      }
    }
  },
  data () {
    // var typeError = this.type - 5
    // if (this.type > 8) {
    //   var typeColor = 8
    // } else {
    //   typeColor = this.type
    // }
    return {
      message: {
        Al100: this.$lang.ui.app.l100,
        Al101: this.$lang.ui.app.l101,
        Al102: this.$lang.ui.app.l102,
        Al103: this.$lang.ui.app.l103,
        Al104: this.$lang.ui.app.l104,
        Al105: this.$lang.ui.app.l105,
        Al106: this.$lang.ui.app.l106,
        Al107: this.$lang.ui.app.l107,
        Al108: this.$lang.ui.app.l108,
        Al109: this.$lang.ui.app.l109,
        Al110: this.$lang.ui.app.l110,
        Al111: this.$lang.ui.app.l111,
        Al150: this.$lang.ui.app.l150,
        Al151: this.$lang.ui.app.l151,
        Al180: this.$lang.ui.app.l180,
        Sl161: this.$lang.ui.system.l161
      },
      show: true,
      delPackageId: '',
      // typeError: typeError,
      // typeColor: typeColor,
      config: [
        {
          barColor: '#999'
          // barColor: '#97a8be'
        },
        {
          // barColor: '#01d48f'
          barColor: '#007bc5'
        },
        {
          barColor: '#ddf0fb'
        },
        {
          barColor: '#999'
        },
        {
          barColor: '#007bc5'
          // barColor: '#01d48f'
        },
        {
          barColor: '#007bc5'
          // barColor: '#01d48f'
        },
        {
          barColor: '#999'
          // barColor: '#97a8be'
        },
        {
          barColor: '#999'
          // barColor: '#97a8be'
        },
        {
          barColor: '#999'
          // barColor: '#97a8be'
        }
      ]
    }
  },
  props: {
    id: String,
    title: String,
    index: Number,
    fileClass: String,
    percent: {
      type: String,
      default: '0%'
    },
    com_time: String,
    project: String,
    type: {
      type: Number,
      default: 0
    },
    taskType: String,
    num: Number,
    bitrate: String,
    // statusShow: false,
    iconShow: {
      iconDelete: true,
      iconStop: true,
      iconStart: true,
      iconTop: true
    },
    // remainTime: '',
    // durationTime: '',
    listType: String,
    // size: '',
    isMore: Object,
    opEvent: String,
    tasks: []
  },
  methods: {
    start (type, id) {
      this.iconShow.iconStart = false
      this.$app.appStart(type, id, response => {
        if (response.error === 0 || response.error === 100) {
        }
      })
    },
    stop (type, id) {
      this.iconShow.iconStop = false
      this.$app.appStop(type, id, response => {
        if (response.error === 0 || response.error === 100) {
        }
      })
    },
    del (type, id) {
      this.iconShow.iconDelete = false
      if (type === 'upload') {
        if (this.type !== 2) {
          this.$app.appStop(type, id, response => {
            if (response.error === 0 || response.error === 100) {
              this.$app.appDelete(type, id, response => {
                if (response.error === 0 || response.error === 100) {
                  // let space = this.space.id
                  let e = {
                    taskType: type
                  }
                  this.$app.list(e, response => {
                    for (let value of response.tasks) {
                      if (id === value.taskId) {
                        this.delPackageId = value.packageId
                        this.$http.delete('/cydex/api/v1/packages/' + this.delPackageId).then(response => {
                        })
                      }
                    }
                  })
                  // setTimeout (() => {
                  //   this.$http.get('/cydex/api/v1/packages', {params: {'project_id': this.space.id,}})
                  //   .then(response => {
                  //     for (let value of response.data.packages) {
                  //       if (this.delPackageId === value.id && value.operation === 'u') {
                  //         this.$http.delete("/cydex/api/v1/packages/" + this.delPackageId).then(response => {
                  //           console.log(response)
                  //         });
                  //       }
                  //     }
                  //   })
                  // })
                }
              })
            }
          })
        } else {
          this.$app.appDelete(type, id, response => {
            if (response.error === 0 || response.error === 100) {
            }
          })
        }
      } else if (type === 'download') {
        if (this.type !== 2) {
          this.$app.appStop(type, id, response => {
            if (response.error === 0 || response.error === 100) {
              this.$app.appDelete(type, id, response => {
                if (response.error === 0 || response.error === 100) {

                }
              })
            }
          })
        } else {
          this.$app.appDelete(type, id, response => {
            if (response.error === 0 || response.error === 100) {
            }
          })
        }
      }
    },
    top (type, id) {
      this.iconShow.iconTop = false
      this.$app.setTaskIndex(type, id, 0, response => {
        if (response.error === 0 || response.error === 100) {
          // this.$emit('uploadList')
        }
      })
    },
    showMore () {
      this.$emit('showMore')
    }
  }
}
</script>

<style lang="css" scoped>
.file {
  z-index: 2;
  margin: 10px 0;
  position: relative;
  color: #424242;
  width: 100%;
  height: 45px;
  background-color: #ebebeb;
  border-radius: 4px;
  font-size: 14px;
}
.file.choose {
  box-shadow: 0px 2px 5px 0px #aaaaaa;
}
.file.more {
  margin: 6px 0;
}
.bar,
.top {
  position: absolute;
  cursor: pointer;
  overflow: hidden;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}
.bottom {
  display: none;
  position: absolute;
  cursor: pointer;
  overflow: hidden;
  top: 30px;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 4;
}
.project {
  position: relative;
  float: left;
  width: 45px;
  height: 45px;
  overflow: hidden;
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
}
.project i {
  margin: 11px;
}
.name {
  position: relative;
  padding-left: 5px;
  width: 26%;
  margin-right: 20px;
  font-weight: 600;
  float: left;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.name:hover {
  color: #007bc5;
}
.status {
  position: relative;
  height: 100%;
  float: left;
  width: 180px;
  padding-left: 5px;
  font-size: 12px;
}
.percent-line {
  position: relative;
  float: left;
  width: 180px;
  line-height: 45px;
}
.percent-line span{
  float: right;
}
.line {
  position: relative;
  display: inline-block;
  border: 1px solid #bbb;
  width: calc(100% - 40px);
  height: 8px;
  border-radius: 10px;
}
.w-line {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
}
.info {
  display: block;;
  float: right;
  height: 100%;
  width: 130px;
}
.operation {
  display: none;
  position: absolute;
  background-color: #ebebeb;
  right: 7px;
  top: 0;
  bottom: 0;
  width: 130px;
}
.top:hover .info {
  display: none;
}
.top:hover .operation {
  display: block;
}
.bit,
.percent {
  font-weight: 600;
  font-size: 14px;
  float: right;
}
.time {
  font-weight: 600;
  font-size: 14px;
  float: right;
}
.bit {
  width: 90px;
  text-align: right;
  padding-right: 10px;
}
.percent {
  display: none;
  width: 40px;
  text-align: right;
}
.o-icon {
  display: block;
  float: right;
  margin: 10px 12px auto 0;
  width: 25px;
  height: 25px;
  line-height: 25px;
  text-align: center;
  color: #48576a;
}
.bar {
  position: absolute;
  top: 0;
  bottom: 0;
  border-radius: 4px;
  /*border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;*/
  left: 0;
  right: 0;
  line-height: 35px;
  z-index: 3;
}
.w-bar {
  display: none;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 0;
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
}
.top {
  padding: 0 8px 0 0;
  line-height: 45px;
  text-align: left;
  z-index: 4;
  color: #444;
}
.hover {
  display: none;
}
.top:hover .hover {
  display: inline-block;
}
.o-icon:hover .op {
  color: #444;
}
.o-icon:hover .n-op {
  color: #d9534f;
}
.file.more {
  height: 50px;
}
.file.more .project.a {
  display: none;
}
.file.more .top {
  padding-left: 8px;
  height: 30px;
  line-height: 30px;
}
.file.more .bottom {
  display: block;
  padding: 0 8px;
  line-height: 14px;
}
.file.more .o-icon {
  margin-top: 3px;
}
.file.more .bottom .name {
  height: 20px;
  font-weight: normal;
  text-align: left;
  font-size: 12px;
}
.file.more .status {
  text-align: left;
}
.file.more .over {
  position: absolute;
  text-align: right;
  width: 178px;
  bottom: 0;
  height: 20px;
  right: 8px;
}
.bottom .status {
  width: 140px;
}
.bottom .over {
  width: 220px !important;
}
.show-error {
  display: block;
  height: 45px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
@media (max-width: 1000px) {
  .name {
    width: 25%;
    margin-right: 0;
  }
  .status {
    width: 150px;
  }
  .percent-line {
    width: 150px;
  }
  .percent-line .line {
    width: calc(100% - 45px);
  }
}
</style>
